export const globalWindow = window;

export const getWindowProperty = <T extends keyof Window>(
  property: T
): Window[typeof property] => (globalWindow as unknown as Window)[property];
